import { InputAdornment, TextField, type TextFieldProps } from "@mui/material"
import { Search } from "lucide-mui"
import React from "react"
import { useDebounce } from "rooks"

type SearchInputProps = {
  query: string
  setQuery: (query: string) => void
  onSearch: (query: string) => void
  InputProps?: Record<string, unknown>
  initialValue?: string
} & TextFieldProps

const SearchInput: React.FC<SearchInputProps> = ({
  query,
  setQuery,
  onSearch,
  initialValue: _initialValue,
  InputProps = {},
  ...props
}) => {
  const debouncedOnSearch = useDebounce(onSearch, 300)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setQuery(value)
    debouncedOnSearch(value)
  }

  return (
    <TextField
      value={query}
      onChange={handleChange}
      placeholder="Search..."
      data-testid="search-input-field"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Search className="w-5 h-5" />
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...props}
    />
  )
}

export default SearchInput
